import { ShieldCheck, Navigation, Accessibility, MessageSquare } from 'lucide-react';

import type { SiteContent } from '../../content/types';
import { Card, CardContent } from '../ui/card';
import { Container } from '../layout/container';

interface TrustStripProps {
  content: SiteContent;
}

const iconOrder = [ShieldCheck, Navigation, Accessibility, MessageSquare];

export function TrustStrip({ content }: TrustStripProps): JSX.Element {
  return (
    <section className="py-6 sm:py-8">
      <Container>
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {content.trustStrip.items.map((item, index) => {
            const Icon = iconOrder[index % iconOrder.length];
            return (
              <Card key={item.title} className="h-full bg-white/95">
                <CardContent className="flex h-full gap-3 p-5">
                  <div className="mt-0.5 rounded-xl bg-[color:var(--color-primary-soft)] p-2 text-[color:var(--color-primary)]">
                    <Icon className="h-4 w-4" />
                  </div>
                  <div className="space-y-1">
                    <h3 className="text-sm font-semibold text-[color:var(--color-text)]">{item.title}</h3>
                    <p className="text-sm leading-relaxed text-[color:var(--color-muted)]">{item.text}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
